import { Box, TextField, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../stores/store';
import { updateTypeMemo } from '../../../stores/inspectionTypeData/slice';
import { useTranslation } from 'react-i18next';
import { MaxLength } from '../../../_constants/maxLengthConst';
import { useEffect, useState } from 'react';

type MemoTextAreaProps = {
  memo: string;
};

const MemoTextArea: React.FC<MemoTextAreaProps> = ({ memo }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { categoryId, typeId } = useSelector(
    (state: RootState) => state.selectIds,
  );
  const [tempMemo, setTempMemo] = useState(memo);

  useEffect(() => {
    // 中項目遷移でリセット
    setTempMemo(memo);
  }, [typeId]);

  const onChangeMemo = (newValue: string) => {
    setTempMemo(newValue);
  };

  const onBlurMemo = () => {
    // 過剰レンダリング防止のため、フォーカスアウトしてからdispatch
    dispatch(updateTypeMemo({ categoryId, typeId, memo: tempMemo }));
  };

  return (
    <Box sx={{ position: 'relative', py: 2 }}>
      <TextField
        label={t('LBL_MEMO')}
        variant="outlined"
        size="small"
        multiline
        minRows={3}
        slotProps={{
          htmlInput: {
            maxLength: MaxLength.Inspection.MEMO,
            sx: { pb: 2 },
          },
        }}
        onChange={(e) => onChangeMemo(e.target.value)}
        onBlur={onBlurMemo}
        value={tempMemo}
        sx={{
          bgcolor: theme.palette.background.default,
          width: '100%',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 20,
          right: 16,
          fontSize: '0.75rem',
        }}
      >
        {tempMemo.length} / {MaxLength.Inspection.MEMO}
      </Box>
    </Box>
  );
};

export default MemoTextArea;
